import type { ThemeOptions } from '@material-ui/core/styles';

const themeColor = '#523BE4';
const themeDarkColor = '#3D2CA8';
const themeLightColor = '#EEE5FE';
const themeDisabledColor = '#523be45e';

export default {
  palette: {
    primary: {
      main: themeColor,
      light: themeLightColor,
      dark: themeDarkColor,
    },
    secondary: {
      main: themeLightColor,
    },
  },

  /** Global CSS */
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': ['Lyft', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(','),

        // Override step counter text.
        '.stepCountTitle': {
          fontWeight: '400 !important',
          fontSize: '12px !important',
        },

        // Override policy modal style.
        '.policyModalCustomBg': {
          backgroundColor: '#f1f4f6 !important',
        },

        // Override policy modal button style.
        '.policyModalCustomButton': {
          backgroundColor: '#f1f4f6 !important',
          border: '1px solid rgba(12, 11, 49, 0.45) !important',
          padding: '0.5rem 0.5rem !important',
          color: '#0C0B31 !important',
        },

        // Override policy modal input style.
        '.policyModalCustomInput': {
          backgroundColor: '#f1f4f6 !important',
          '& .MuiInputBase-root': {
            backgroundColor: '#f1f4f6 !important',
          },
          '& .MuiInputBase-input': {
            backgroundColor: '#f1f4f6 !important',
          },
        },
        '.policyAddCarAttribButton': {
          borderRadius: '0.25rem !important',
        },
        // Override for single cars/drivers page - Add button.
        '.policySingleAddAction': {
          borderRadius: '3rem !important',
          borderColor: 'rgba(12,11,49,0.45) !important',
        },

        // Override for single cars/drivers page - border color.
        '.policySingleItemsContainer': {
          borderColor: 'rgba(12,11,49,0.45) !important',
        },

        // Override for single cars/drivers page - title font.
        '.policySingleItemsTitle': {
          fontWeight: '700 !important',
        },

        'label + div .MuiOutlinedInput-input': {
          paddingBottom: '0.5rem',
        },

        body: {
          fontFamily: `${['Lyft', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')} !important`,
        },
      },
    },
    MuiTypography: {
      root: {
        fontFamily: `${['Lyft', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')} !important`,
      },
    },
    MuiOutlinedInput: {
      root: {
        fontFamily: `${['Lyft', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')} !important`,
        borderRadius: '0.375rem',
        borderWidth: '0.071em',
        '& fieldset': {
          borderColor: '#0C0B31',
        },
        '&$focused $notchedOutline': {
          borderColor: '#0C0B31',
        },
        '&$disabled $notchedOutline': {
          borderColor: '#0C0B31',
        },
      },
    },
    MuiInputLabel: {
      outlined: {
        transform: 'translate(14px, 15px) scale(1)',
        '&$shrink': {
          top: '0.725rem',
          transform: 'translate(14px, -7px) scale(0.9)',
        },
      },
    },
    PrivateNotchedOutline: {
      legendLabelled: {
        display: 'none',
      },
    },
    MuiButton: {
      root: { borderRadius: '3rem !important' },
      label: {
        fontFamily: `${['Lyft', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')} !important`,
      },
      textPrimary: {
        color: themeDarkColor,
      },
      startIcon: {
        left: '7% !important',
      },
      containedPrimary: {
        backgroundColor: themeColor,
        '&$disabled': {
          backgroundColor: themeDisabledColor,
        },
        '&:hover': {
          backgroundColor: themeDarkColor,
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: themeColor,
        '&$checked': {
          color: themeColor,
        },
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'inherit',
        },
      },
    },
  },
} as ThemeOptions;
